import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { register } from "../../Redux/actions/user";
import techforceLogo from "../../Assets/techforce-logo.png";
import clock from "../../Assets/clock.svg";
import ai from "../../Assets/artificial-intelligence.svg";
import worldWide from "../../Assets/worldwide.svg";
import employee from "../../Assets/orange-employee.svg";
import emailicon from "../../Assets/email.svg";
import axios from 'axios';
import "./index.css";

function UserRegistration(props) {

  let [email, setEmail] = useState();
  let [err, setErr] = useState(false);
  let [loading,setLoading] = useState(false)
  let [msg,setMsg] = useState(false)
  const [subscription_id, setSubscription] = useState('')

  useEffect(() => {
    const parsed = queryString.parse(props.location.search);
    if(parsed.subscriptionId === '0'|| parsed.subscriptionId === '1'){
      setSubscription(parsed.subscriptionId)
    }else{
      props.history.push("/")
    }
  },[props.location, props.history])

  const handleChange = (e) => {
      setEmail(e.target.value)
      setErr(false);
      setMsg(false)
  };

  const handleSubmit = async (e) => { 
      e.preventDefault();
      setLoading(true)
      let mail=email.split('@')
      // let  {data}=await axios.get(`https://open.kickbox.com/v1/disposable/${mail[1]}`)
      // if(!data.disposable){
        let data = await register({ email, subscription_id});
        if (data.status === 201) {
          setMsg(`Congratulations! Your Techforce.ai account is created and verification email has been sent to ${email}. `)
          setLoading(false)
        } 
        else if (data.status === 409) {
          setMsg("User already exists Please register with new User")
          setLoading(false)
        }
      // } else {
      //         setErr(true);
      //  }
    };
    
  return (
    <div className="register">
      <div className="col-md-7 register-1" >
        <div className="header">
          <img src={techforceLogo} width="200" alt="logo"></img>
        </div>
            <h1>Create your free community account for unlimited robotic process automation.</h1>
            <p>One account for all your intelligent automation needs on your premise or our cloud.</p>
      <div  className="row">
          <h4>Join our community of 1400+ Developers to give your Automation journey a boost</h4>
              <div className=" main-card" >
                  <div className="col-md-3 col-xs-6 cards">
                        <div className="box">
                            <div className="center">
                                <img src={ai} width="30" alt="logo"></img>
                                <h2>250+</h2>
                                <p>E-Workers <br></br> deployed</p>
                            </div>
                        </div>
                  </div>
                  <div className="col-md-3 col-xs-6 cards">
                      <div className="box">
                          <div className="center">
                              <img src={ai} width="30" alt="logo"></img>
                              <h2>40+</h2>
                              <p>Enterprise App Integrations to scale Automation faster</p>
                          </div>
                      </div>
                  </div>
                  <div className="col-md-3 col-xs-6 cards">
                      <div className="box">
                          <div className="center">
                              <img src={worldWide} width="30" alt="logo"></img>
                              <h2>24x7 </h2>
                              <p>Community and Priority support options available</p>
                          </div>
                      </div>
                  </div>
                  <div className="col-md-3 col-xs-6 cards">
                      <div className="box">
                          <div className="center" style={{marginRight:"20px"}}>
                              <img src={employee} width="25" alt="logo"></img>
                              <p style={{marginTop:"15px"}}>Monetize your custom Integrations through SaaS marketplace</p>
                          </div>
                      </div>
                  </div>
            </div>
          </div>
      </div>
      <div className="col-md-5 form-right register-1" >
          <div className="form-container">
              <div className="form-header">
                <h2>Signup</h2>
              </div>
                <form onSubmit={handleSubmit}>
                  {msg !== false?<div className="alert alert-success" role="alert">{msg}</div>:"" }
                  {err ? <div className="alert alert-danger" role="alert">
                    Please enter Valid Business Email-ID
                    </div> :""
                  }
                      <div>
                          <label htmlFor="contact" className="control-label " >
                          Business Email 
                          </label>
                          <div class="inputBox">
                            <input
                              className="form-control"
                              name="email"
                              value={email}
                              onChange={handleChange}
                              type="email"
                              placeholder="Enter" 
                              required
                            />
                            <span className="ico"> <img src={emailicon} width="20" alt="logo"></img></span>
                          </div>
                      </div>
                      <div className="form-group" style={{marginTop:"10px"}}>
                          <div className="center">
                            <button className="btn text-center" type="submit" >{loading ? <i
                              style={{ fontSize: "15px", color: "#ffffff"}}
                              className="fas fa-circle-notch fa-spin"
                              ></i> : "SIGN UP" }</button>
                          </div>
                        <div className="login-link text-center">
                        Already have an account? <a href="/" style={{color:"#02ce9d"}}>  Login</a>
                        </div>
                      </div>
                      <div class="form-group form-check">
                            <label className="form-check-label" for="exampleCheck1">
                              {" "}By registering, you agree to the {" "}
                              <strong style={{ color: "#02ce9d" }}>
                                <a
                                  style={{ display: "table-cell" ,color:"#02ce9d"}}
                                  href="./conditions.html"
                                  target="_blank"
                                >
                                  Terms and Conditions
                                </a>
                              </strong>
                            </label>
                      </div>
                 </form>
              </div>
          </div>
      </div>
  );
}

export default UserRegistration;
